import React, {useEffect, useRef, useState} from 'react';
import {Breadcrumb, BreadcrumbItem} from "reactstrap";
import {Link} from "react-router-dom";
import Container from "@material-ui/core/Container";
import { Typography } from '@mui/material';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";
import wallPaper from "../assets/static/images/team-work.jpg";
// import applicationForm from '../assets/static/docs/EHS-application-form.pdf'
import { useParams } from 'react-router-dom';
import supportedLiving from '../assets/static/images/job-ad.jpg'
import {Helmet} from "react-helmet";
import CssBaseline from "@material-ui/core/CssBaseline";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useLocation } from "react-router-dom";
import ReactMarkdown from 'react-markdown';
import TextField from "@material-ui/core/TextField";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {BRAND_HEADLINE, BRAND_NAME, META_CONTENT} from "../shared/consts";



const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    padding: theme.spacing(14, 0, 6),
    backgroundImage: `url(${wallPaper})`,
    backgroundColor: 'rgba(0, 0, 0, 0.13)',
    backgroundBlendMode: 'darken',
    backgroundSize: 'cover'
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  cardTitle: {
    fontWeight: 'bold',
    paddingBottom: '25px'
  },
  cardContentText: {
    paddingBottom: '20px',
    fontWeight: 'bold',
    textAlign: 'left'
  },
  newLineDiv: {
    display: 'block',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 12px 24px 0 rgba(0,0,0,0.08)'
  },
  paperContent: {
    height: '100px',
    textAlign: 'left',
  },
  cardMedia: {
    paddingTop: '16.25%', // 16:9
    marginBottom: '15px',
  },
  cardContent: {
    flexGrow: 1,
  },
  root: {
    paddingBottom: '80px',
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  sections: {
    textAlign: 'center'
  },
  services: {
    marginTop: '30px'
  },
  sectionTitles: {
    fontWeight: 'bolder',
    color: 'black',
    paddingBottom: '30px',
    paddingTop: '64px'
  },
  footer: {
    backgroundColor: '#2f3030',
    padding: theme.spacing(6),
    color: theme.palette.background.paper,
  },
  preFooter: {
    backgroundColor: '#dfe0e0',
    padding: theme.spacing(4),
    color: theme.palette.background.paper,
  },
    formWrap: {
    marginTop: theme.spacing(3),
    textAlign: "left",
  },
  formGrid: {
    marginTop: theme.spacing(2),
  },
  fieldWrap: {
    position: "relative",
  },
  validIcon: {
    position: "absolute",
    right: 12,
    top: "50%",
    transform: "translateY(-50%)",
    color: "#2e7d32",
    fontSize: 18,
    pointerEvents: "none",
  },
  uploadZone: {
    marginTop: theme.spacing(3),
    border: "2px dashed #d0d5dd",
    borderRadius: 10,
    padding: theme.spacing(3),
    textAlign: "center",
    backgroundColor: "#fafafa",
    transition: "all 0.15s ease-in-out",
  },
  uploadZoneActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: "#f4f8ff",
  },
  uploadIcon: {
    width: 44,
    height: 44,
    borderRadius: 999,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#eef2ff",
    marginBottom: theme.spacing(1),
  },
  uploadMeta: {
    marginTop: theme.spacing(1),
    color: "#667085",
    fontSize: 13,
  },
  filePill: {
    marginTop: theme.spacing(2),
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 12px",
    borderRadius: 999,
    backgroundColor: "#f2f4f7",
    border: "1px solid #e4e7ec",
    fontSize: 13,
  },
  submitRow: {
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
  },

}));

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

export default function JobPost(props) {

  const [job, setJob] = useState({})
  const [loadingJob, setLoadingJob] = useState(true);
  const [jobError, setJobError] = useState(null);
  const params = useParams()

  useEffect(() => {
    console.log(params)
    loadData()
  }, [])

  const loadData = async () => {
  try {
    setLoadingJob(true);
    setJobError(null);

    const response = await fetch("https://www.comfycraft.co.uk/api/kea-vacancies-info");
    if (!response.ok) throw new Error("Failed to load job data");

    const data = await response.json();
    const jobID = parseInt(params.id, 10);

    const selected = data?.results?.[jobID];
    if (!selected) throw new Error("Job not found");

    setJob(selected);
  } catch (err) {
    console.error(err);
    setJobError(err.message || "Error loading job");
  } finally {
    setLoadingJob(false);
  }
};


  const classes = useStyles();

  const myRef = useRef(null)
  const executeScroll = () => scrollToRef(myRef)

  const webRef = useRef(null)
  const executeWebScroll = () => scrollToRef(webRef)

  const location = useLocation();

    const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  });
  const [resumeFile, setResumeFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const isFilled = (v) => (v || "").trim().length > 0;

  const onChange = (key) => (eOrValue) => {
  // Supports both: onChange(event) and onChange(value)
  const value =
    eOrValue && eOrValue.target ? eOrValue.target.value : (eOrValue ?? "");

  setForm((p) => ({ ...p, [key]: value }));
};


  const handlePickFile = (e) => {
    const file = e.target.files && e.target.files[0];
    if (file) setResumeFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files && e.dataTransfer.files[0];
    if (file) setResumeFile(file);
  };

  const canSubmit =
    isFilled(form.first_name) &&
    isFilled(form.last_name) &&
    isValidEmail(form.email) &&
    isFilled(form.phone) &&
    !!resumeFile;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    try {
      setSubmitting(true);

      const fd = new FormData();
      fd.append("job_id", String(job?.Job_ID ?? params.id));
      fd.append("job_title", String(job?.Job_Title ?? ""));
      fd.append("first_name", form.first_name);
      fd.append("last_name", form.last_name);
      fd.append("email", form.email);
      fd.append("phone", form.phone);
      fd.append("resume", resumeFile);

      // TODO: replace with your real backend endpoint
      const res = await fetch("https://www.comfycraft.co.uk/api/kea-vacancies-info/", {
        method: "POST",
        body: fd,
      });

      if (!res.ok) throw new Error("Failed to submit");

      // Simple success reset
      setForm({ first_name: "", last_name: "", email: "", phone: "" });
      setResumeFile(null);
      alert("Application submitted successfully.");
    } catch (err) {
      console.error(err);
      alert("Sorry — we couldn’t submit your application. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };


  useEffect(() => {
    const section = location.section
    if (section === 'IT Support') {
      executeScroll()
    }
    else if (section === 'Web Design' || section === 'Digital Marketing') {
      executeWebScroll()
    } else {
      window.scrollTo(0, 0)
    }
  }, [location])


  return (
    <React.Fragment>
      <Helmet>
        <meta name="description"
          content={META_CONTENT} />
        <title>{BRAND_NAME} - {BRAND_HEADLINE}</title>
      </Helmet>
      <CssBaseline />
      <main>
        {/* Hero unit */}
        <div className={classes.heroContent}>
          <Breadcrumb>
            <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
            <BreadcrumbItem><Link to="/careers">Vacancies</Link></BreadcrumbItem>
            <BreadcrumbItem active>{job.Job_Title}</BreadcrumbItem>
          </Breadcrumb>
          <Container maxWidth="sm">
            <Typography
              component="h1"
              variant="h4"
              align="center"
              // color="textPrimary"
              style={{fontWeight: 'bold', color: 'white'}}
              gutterBottom>
              <span style={{backgroundColor: 'rgb(245, 195, 0)', padding: '0.0em 0.2em 0.0em 0.2em'}}>Job Post</span>
            </Typography>
          </Container>
        </div>
      </main>

      <Container ref={webRef} maxWidth="md" className={classes.sections}>
        <div
          className={classes.sectionTitles}>
        </div>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} >
            <Card className={classes.card} >
              <CardMedia
                className={classes.cardMedia}
                image={supportedLiving}
                title="Job Vacancy"
              />
              <CardContent className={classes.cardContent}>
                <Typography gutterBottom variant="h6" component="h2" className={classes.cardTitle}>
                  {job.Job_Title}
                </Typography>
                <div className={classes.cardContentText}>
                  <Typography>
                    {loadingJob ? (
                      <div style={{ padding: "20px 0", textAlign: "center" }}>
                        <CircularProgress />
                        <div style={{ marginTop: 10, fontSize: 14, color: "#667085" }}>
                          Loading job details...
                        </div>
                      </div>
                    ) : jobError ? (
                      <div style={{ padding: "12px", border: "1px solid #f5c2c7", background: "#f8d7da", borderRadius: 8 }}>
                        {jobError}
                      </div>
                    ) : (
                      <ReactMarkdown>{job?.Job_Description || ""}</ReactMarkdown>
                    )}
                  </Typography>

                  <br/>
                  <Typography
                    component="h1"
                    variant="h5"
                    align="center"
                    color="textPrimary"
                    gutterBottom
                    className={classes.sectionTitles}>
                    Apply for this role
                  </Typography>
                  <div>
                    {/*Here add the form and upload functionality*/}
                    <form className={classes.formWrap} onSubmit={handleSubmit}>
                      <Grid container spacing={2} className={classes.formGrid}>
                        <Grid item xs={12} sm={6}>
                          <div className={classes.fieldWrap}>
                            <TextField
                              label="First Name"
                              variant="outlined"
                              fullWidth
                              value={form.first_name}
                              onChange={onChange("first_name")}
                            />
                            {isFilled(form.first_name) && <CheckCircleIcon className={classes.validIcon} />}
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <div className={classes.fieldWrap}>
                            <TextField
                              label="Last Name"
                              variant="outlined"
                              fullWidth
                              value={form.last_name}
                              onChange={onChange("last_name")}
                            />
                            {isFilled(form.last_name) && <CheckCircleIcon className={classes.validIcon} />}
                          </div>
                        </Grid>

                        <Grid item xs={12}>
                          <div className={classes.fieldWrap}>
                            <TextField
                              label="Email"
                              variant="outlined"
                              fullWidth
                              value={form.email}
                              onChange={onChange("email")}
                            />
                            {isValidEmail(form.email) && <CheckCircleIcon className={classes.validIcon} />}
                          </div>
                        </Grid>

                        <Grid item xs={12}>
                          <div className={classes.fieldWrap}>
                            <TextField
                              label="Phone Number"
                              variant="outlined"
                              fullWidth
                              value={form.phone}
                              onChange={onChange("phone")}
                            />
                            {isFilled(form.phone) && <CheckCircleIcon className={classes.validIcon} />}
                          </div>
                        </Grid>

                        <Grid item xs={12}>
                          <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                            Resume
                          </Typography>

                          <input
                            id="resume-upload"
                            type="file"
                            accept=".pdf,.doc,.docx"
                            style={{ display: "none" }}
                            onChange={handlePickFile}
                          />

                          <div
                            className={`${classes.uploadZone} ${dragActive ? classes.uploadZoneActive : ""}`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                          >
                            <div className={classes.uploadIcon}>
                              <CloudUploadIcon />
                            </div>

                            <div>
                              <label htmlFor="resume-upload">
                                <Button variant="outlined" component="span">
                                  Add File
                                </Button>
                              </label>
                            </div>

                            <div className={classes.uploadMeta}>Drag Here to Upload</div>

                            {resumeFile && (
                              <div className={classes.filePill}>
                                <strong>{resumeFile.name}</strong>
                                <span style={{ color: "#667085" }}>
                                  ({Math.ceil(resumeFile.size / 1024)} KB)
                                </span>
                                <Button size="small" onClick={() => setResumeFile(null)}>
                                  Remove
                                </Button>
                              </div>
                            )}
                          </div>
                        </Grid>

                        <Grid item xs={12}>
                          <div className={classes.submitRow}>
                            <Button
                              type="submit"
                              variant="contained"
                              color="primary"
                              disabled={!canSubmit || submitting}
                            >
                              {submitting ? "Submitting..." : "Submit Application"}
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </form>

                  </div>
                </div>
              </CardContent>
              <CardActions style={{marginBottom: '20px', alignItems: 'center', justifyContent: 'center'}}>
                {/*<Button size="small" variant="contained" color="secondary" onClick={() => handleButtonClick()}>*/}
                {/*  Submit Application*/}
                {/*</Button>*/}
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
}